import React, { ReactElement } from 'react'
import { Flex, Slide } from '@chakra-ui/react'

const JBottomSheet = (props) => {
  const { 
    isOpen, 
    onClose, 
    children, 
  } = props

  return (
    <Slide 
      direction='bottom' 
      in={isOpen} 
      style={{zIndex: 9999}}
    >
      <Flex direction='column' height='100vh'>
        <Flex 
          position='absolute' 
          backgroundColor='black' 
          top='0px' 
          right='0px' 
          bottom='0px' 
          left='0px' 
          opacity='0.5'
          onClick={onClose}
        />
        <Flex 
          backgroundColor='background' 
          padding='24px' 
          position='relative' 
          marginTop='auto' 
          borderRadius='16px 16px 0px 0px'
          direction='column'
          style={{ zIndex:9991 }}
          overflow='auto'
        >
          {children}
        </Flex>
      </Flex>
    </Slide>
  )
}

export default JBottomSheet